import { ArrowUp, ArrowDown } from 'lucide-react'
import { Sparkline } from './Sparkline'

interface StatProps {
  label: React.ReactNode
  value: string | number
  delta?: string
  deltaDir?: 'up' | 'down'
  sparkData?: number[]
}

export function Stat({ label, value, delta, deltaDir, sparkData }: StatProps) {
  return (
    <div className="stat">
      <div className="stat-label">{label}</div>
      <div className="stat-value tabular">{value}</div>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginTop: 4, gap: 8 }}>
        {delta && deltaDir && (
          <div className={`stat-delta ${deltaDir}`}>
            {deltaDir === 'up' ? <ArrowUp size={12} /> : <ArrowDown size={12} />}
            {delta}
          </div>
        )}
        {sparkData && (
          <div style={{ flex: 1, maxWidth: 120 }}>
            <Sparkline data={sparkData} />
          </div>
        )}
      </div>
    </div>
  )
}
